import React from 'react';

import { DownloadIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DownloadButton = ({
  title,
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Control.IconButton
      className={className}
      data-testid="downloadButton"
      icon={<DownloadIcon />}
      kind="primary"
      onClick={onClick}
      title={title || t('button.download')}
      variant="dimmed"
    />
  );
};

DownloadButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

DownloadButton.defaultProps = {
  className: undefined,
  title: undefined,
};

export default DownloadButton;
